<template lang="pug">
.thumbnail-grid-container
  .thumbnail-grid(v-if="thumbnails.length > 0")
    .thumbnail-item(
      v-for="(thumbnail, idx) in thumbnails.slice(0, 4)"
      :key="thumbnail.filename"
      @click="openModal(idx)"
      :title="`View page ${idx + 1}`"
    )
      img(:src="thumbnail.url" :alt="`Page ${idx + 1}`")
      .page-number {{ idx + 1 }}
    .thumbnail-more(
      v-if="thumbnails.length > 4"
      @click="openModal(0)"
      title="View all pages"
    )
      .more-text +{{ thumbnails.length - 4 }}
      .more-label more
  
  .modal.fade(ref="modal" tabindex="-1" aria-hidden="true")
    .modal-dialog.modal-xl
      .modal-content
        .modal-header
          h5.modal-title {{ previewTitle }}
          button.close(type="button" @click="closeModal")
            span(aria-hidden="true") &times;
        .modal-body
          .thumbnail-modal-grid
            .thumbnail-modal-item(
              v-for="(thumbnail, idx) in thumbnails"
              :key="thumbnail.filename"
            )
              img(:src="thumbnail.url" :alt="`Page ${idx + 1}`")
              .modal-page-number Page {{ idx + 1 }}
</template>

<script>
export default {
  props: {
    previewId: {
      type: Number,
      required: true
    },
    previewTitle: {
      type: String,
      default: 'Untitled Preview'
    },
    thumbnails: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    openModal(startIndex = 0) {
      const modal = jQuery(this.$refs.modal)
      modal.modal('show')
      
      // Scroll to the clicked thumbnail if not starting from beginning
      if (startIndex > 0) {
        this.$nextTick(() => {
          const item = modal.find('.thumbnail-modal-item').eq(startIndex)
          if (item.length) {
            modal.find('.modal-body').scrollTop(item.position().top)
          }
        })
      }
    },

    closeModal() {
      jQuery(this.$refs.modal).modal('hide')
    }
  }
}
</script>

<style scoped>
.thumbnail-grid-container {
  margin-top: 0.75rem;
}

.thumbnail-grid {
  display: flex;
  gap: 0.5rem;
  overflow-x: auto;
  padding: 0.25rem 0;
}

.thumbnail-item {
  position: relative;
  flex-shrink: 0;
  width: 70px;
  height: 90px;
  border: 2px solid #dee2e6;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: #f8f9fa;
}

.thumbnail-item:hover {
  border-color: #337ab7;
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.thumbnail-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.page-number {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  padding: 2px;
}

.thumbnail-more {
  flex-shrink: 0;
  width: 70px;
  height: 90px;
  border: 2px dashed #337ab7;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: #f0f7ff;
  transition: all 0.2s ease;
}

.thumbnail-more:hover {
  background-color: #e3f2ff;
  border-color: #2563a8;
  transform: translateY(-2px);
}

.more-text {
  font-size: 18px;
  font-weight: bold;
  color: #337ab7;
}

.more-label {
  font-size: 10px;
  color: #666;
  text-transform: uppercase;
}

/* Thumbnail Modal */
.thumbnail-modal-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1.5rem;
  padding: 1rem;
}

.thumbnail-modal-item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.thumbnail-modal-item img {
  width: 100%;
  height: auto;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.modal-page-number {
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  color: #666;
}

/* Modal overrides */
.modal-xl {
  max-width: 1200px;
}

.modal-body {
  max-height: 70vh;
  overflow-y: auto;
}
</style>
